import _ from "lodash";

const assets = {
  qatar_logo: require("../../../assets/wc/images/sport_world_logo.png"),
};

export default assets;
